import React from 'react'
import { observer } from 'mobx-react-lite'
import { useResearchPage } from './hooks/useResearchPage'
import ExploreTools from './components/ExploreTools/ExploreTools'
import SavedJourneys from './components/SavedJourneys/SavedJourneys'
import CareerFinder from './components/CareerFinder/CareerFinder'
import CountryFinder from './components/CountryFinder/CountryFinder'
import CourseFinder from './components/CourseFinder/CourseFinder'
import UniversityFinder from './components/UniversityFinder/UniversityFinder'
import RecommendationTray from './components/RecommendationTray/RecommendationTray'
import SendRecommendationModal from './components/SendRecommendationModal/SendRecommendationModal'
import ResearchCategoryPicker from './components/ResearchCategoryPicker/ResearchCategoryPicker'
// import ResearchStudentSwitchModal from './components/ResearchStudentSwitchModal/ResearchStudentSwitchModal'
import s from './styles/ResearchPage.module.scss'

const ResearchPage = observer(function ResearchPage() {
	const vm = useResearchPage()

	const trayProps = {
		items: vm.trayItems,
		selectedStudent: vm.selectedStudent,
		selectedStudentName: vm.selectedStudentName,
		onRemove: vm.onTrayRemove,
		onClear: vm.onTrayClear,
		onOpenStudentPicker: vm.openStudentPicker,
	}

	let screen = null
	if (vm.activeScreen === 'main') {
		screen = (
			<>
				<ExploreTools tools={vm.TOOLS} onSelect={vm.onExploreSelect} />
				<SavedJourneys
					journeys={vm.journeys}
					journeysStatus={vm.journeysStatus}
					studentJourneys={vm.studentAitoolsJourneys}
					studentJourneysStatus={vm.studentAitoolsJourneysStatus}
					showStudentSection={Boolean(vm.selectedStudentId)}
					activeJourneyId={vm.activeJourneyId}
					onContinue={vm.onResumeJourney}
					onDelete={vm.onDeleteJourney}
					onViewStudentJourney={vm.onViewStudentJourney}
				/>
			</>
		)
	} else if (vm.activeScreen === 'course') {
		screen = (
			<CourseFinder
				courseCards={vm.courseCards}
				loadingCourses={vm.loadingCourses}
				coursesError={vm.coursesError}
				onRetryCourses={vm.retryCourses}
				draftCareer={vm.career}
				careers={vm.careers}
				categoryDisplayLabel={vm.categoryDisplayLabel}
				subCategoryDisplayLabel={vm.subCategoryDisplayLabel}
				draftCategory={vm.draftCategory}
				selectedCourses={vm.selectedCourses}
				isSelectedCourse={vm.isSelectedCourse}
				selectionPending={vm.selectionPending}
				pendingSelectionId={vm.pendingSelectionId}
				activeDegree={vm.activeDegree}
				onOpenCategoryPicker={vm.openCategoryPicker}
				onSelectCareer={vm.selectDraftCareer}
				onSelectCourse={vm.toggleDraftCourse}
				onApplyDegree={vm.selectDraftDegree}
				onStepClick={vm.onStepperSelect}
			/>
		)
	} else if (vm.activeScreen === 'country') {
		screen = (
			<CountryFinder
				countryCards={vm.countryCards}
				loadingCountries={vm.loadingCountries}
				countriesError={vm.countriesError}
				onRetryCountries={vm.retryCountries}
				draftCareer={vm.career}
				careers={vm.careers}
				selectedCountries={vm.draftCountries}
				isSelectedCountry={vm.isSelectedCountry}
				selectionPending={vm.selectionPending}
				pendingSelectionId={vm.pendingSelectionId}
				categoryDisplayLabel={vm.categoryDisplayLabel}
				subCategoryDisplayLabel={vm.subCategoryDisplayLabel}
				draftCategory={vm.draftCategory}
				onOpenCategoryPicker={vm.openCategoryPicker}
				onSelectCareer={vm.selectDraftCareer}
				onSelectCountry={vm.toggleDraftCountry}
				onStepClick={vm.onStepperSelect}
			/>
		)
	} else if (vm.activeScreen === 'career') {
		screen = (
			<CareerFinder
				careers={vm.careers}
				filteredCareers={vm.filteredCareers}
				loadingProfession={vm.loadingProfession}
				professionsError={vm.professionsError}
				onRetryProfessions={vm.retryProfessions}
				selectedIds={vm.selectedIds}
				isSelectedCareer={vm.isSelectedCareer}
				selectionPending={vm.selectionPending}
				pendingSelectionId={vm.pendingSelectionId}
				query={vm.query}
				role={vm.role}
				categoryDisplayLabel={vm.categoryDisplayLabel}
				subCategoryDisplayLabel={vm.subCategoryDisplayLabel}
				draftCategory={vm.draftCategory}
				onOpenCategoryPicker={vm.openCategoryPicker}
				onQueryChange={vm.setQuery}
				onRoleChange={vm.setRole}
				onToggleCareer={vm.toggleCareer}
				onStepClick={vm.onStepperSelect}
			/>
		)
	} else if (vm.activeScreen === 'college') {
		screen = (
			<UniversityFinder
				newData={vm.universityNewData}
				sortOptions={vm.universitySortOptions}
				sortBy={vm.universitySortBy}
				sortOrder={vm.universitySortOrder}
				loadingUniversities={vm.loadingUniversities}
				universitiesError={vm.universitiesError}
				searchDisabled={vm.universitySearchDisabled}
				setNewData={vm.setUniversityNewData}
				setSearchDisabled={vm.setUniversitySearchDisabled}
				noShortlist={vm.universityNoShortlist}
				showPlaceholders={vm.universityShowPlaceholders}
				isDisableSortBtn={vm.universitySortDisabled}
				isButtonDisabled={vm.universityShowMoreDisabled}
				onSearch={vm.onUniversitySearch}
				onSortChange={vm.onUniversitySortChange}
				onShowMore={vm.onUniversityShowMore}
				onRetryUniversities={vm.retryUniversities}
				items={vm.shortCards}
				onStepClick={vm.onStepperSelect}
				isFetched={vm.universityIsFetched}
				selectedUniversityIds={vm.selectedUniversityIds}
				onToggleUniversity={vm.toggleUniversitySelection}
				studentName={vm.selectedStudentName}
			/>
		)
	}

	return (
		<div className={s.page}>
			<div className={s.content}>{screen}</div>

			{vm.showTray ? <RecommendationTray {...trayProps} /> : null}

			<SendRecommendationModal
				isOpen={vm.isSendOpen}
				sentMessage={vm.sentMessage}
				pickerOrigin={vm.pickerOrigin}
				sendStep={vm.sendStep}
				studentSearch={vm.studentSearch}
				studentQuery={vm.studentQuery}
				visibleStudents={vm.visibleStudents}
				studentGradeTabs={vm.studentGradeTabs}
				studentPickerGrade={vm.studentPickerGrade}
				pendingStudentId={vm.pendingStudentId}
				pendingStudent={vm.pendingStudent}
				selectedStudent={vm.selectedStudent}
				selectedCareers={vm.isSelectedCareer ? vm.selectedCareers : []}
				selectedCountries={vm.selectedCountryItems}
				selectedCourses={vm.selectedCourseItems}
				selectedUniversities={vm.selectedUniversities}
				recommendationKind={vm.recommendationKind}
				onClose={vm.closeSendModal}
				onStudentSearchChange={vm.setStudentSearch}
				onStudentGradeChange={vm.setStudentPickerGrade}
				onSelectPendingStudent={vm.setPendingStudentId}
				onSetSendStep={vm.setSendStep}
				onUseStudent={vm.useStudent}
				onPreviewRecommendation={vm.previewRecommendation}
				onSendRecommendation={vm.sendRecommendation}
			/>

			<ResearchCategoryPicker
				isOpen={vm.categoryPickerOpen}
				initialStep={vm.categoryPickerStep}
				onClose={vm.closeCategoryPicker}
				onCommitted={vm.onCategoryOrSubCategoryCommitted}
				courseMapError={vm.courseMapError}
				courseMapLoading={vm.courseMapLoading}
				onRetryCourseMap={vm.retryCourseMap}
			/>

			{/* Temporarily disabled: auto-switch student without confirm modal.
			<ResearchStudentSwitchModal
				isOpen={vm.pendingSwitchStudentId != null}
				pendingStudentName={vm.pendingSwitchStudentName}
				onKeepResearch={vm.keepCurrentResearchOnSwitch}
				onLoadStudent={vm.loadPendingStudentOnSwitch}
			/>
			*/}
		</div>
	)
})

export default ResearchPage
